export default __webpack_public_path__ + "static/media/image-3.6874d3d6.png";